import React, { ReactNode, useReducer, useMemo } from 'react';
import { userReducer, UserAction } from '../reducers/userReducer';
import { defaultUserContext, UserContextType } from '../models/user.interface';

export const UserContext = React.createContext<{
  state: UserContextType;
  dispatch: React.Dispatch<UserAction>
}>({
  state: defaultUserContext,
  dispatch: () => undefined,
});

export type Props = {
  children: ReactNode;
};

export const UserContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(userReducer, defaultUserContext);

  const userValue = useMemo(() => ({
    state,
    dispatch,
  }), [state]);

  return (
    <UserContext.Provider value={userValue}>
      {children}
    </UserContext.Provider>
  );
};

export function useUserContext() {
  const context = React.useContext(UserContext);

  if (context === undefined){
    throw new Error('useUserContext must be used within a UserContextProvider');
  }

  return context;
}
  
export const UserContextConsumer = UserContext.Consumer;
